<template>
  <div id="app">
    <router-view :key="key" />
  </div>
</template>

<script>
// 判断是否是火狐
let isFireFox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
export default {
  name: 'App',
  computed: {
    key () {
      if (isFireFox) {
        return this.$route.name !== undefined
          ? this.$route.name + new Date()
          : this.$route + new Date()
      }
    }
  },
  watch: {
    $route (to, from) {
      // 获取用户信息
      // let dealerInfo = this.getStorage('dealerInfo')
      if (from.name != null && to.name !== from.name) {
        var UA = navigator.userAgent
        var SPIDER = /spider|googlebot|networkbench|"/i.test(UA)
        var robot = 0
        if (UA.indexOf('SCH-N719') >= 0 && /UCBrowser\/9.9.5.489/i.test(UA)) {
          robot = 1
        }
        if (UA.indexOf('HTC6435LVW') >= 0 && /UCBrowser\/9.9.5.489/i.test(UA)) {
          robot = 1
        }
        if (!SPIDER && !robot) {
          // eslint-disable-next-line no-undef
          truckHomeNew_pv({
            // String 当前页面
            k: encodeURIComponent(location.href),
            // String 来源
            i: !from.fullPath
              ? ''
              : encodeURIComponent(
                location.href.split('#')[0] + '#' + from.fullPath
              )
            // pv浏览打点
            // dealers_uid: dealerInfo && dealerInfo.userid
          }) // 执行卡车之家自己的打点pv
        }
      }
    }
  },
  mounted () {
    // 兼容ie11 ie10 href 不跳转
    function checkIE () {
      return (
        '-ms-scroll-limit' in document.documentElement.style &&
        '-ms-ime-align' in document.documentElement.style
      )
    }
    if (checkIE()) {
      window.addEventListener(
        'hashchange',
        () => {
          var currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        },
        false
      )
    }
  }
}
</script>
<style>
@import 'iview/dist/styles/iview.css';
@import './css/reset.css';
@font-face {
  font-family: 'dealer'; /* project id 596758 */
  src: url('//at.alicdn.com/t/font_596758_ekgke3woj.eot');
  src: url('//at.alicdn.com/t/font_596758_ekgke3woj.eot?#iefix')
      format('embedded-opentype'),
    url('//at.alicdn.com/t/font_596758_ekgke3woj.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_596758_ekgke3woj.woff') format('woff'),
    url('//at.alicdn.com/t/font_596758_ekgke3woj.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_596758_ekgke3woj.svg#iconfont') format('svg');
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: rgb(245, 246, 250);
}
</style>



// WEBPACK FOOTER //
// src/App.vue